import {$} from './jquery-definition.js';
import SmoothScroll from 'smooth-scroll';
import SameWidth from 'same-width';
import {animateInViewport} from "./transition";
import {countUp} from "./modules/countup";

var smoothScroll = new SmoothScroll( 'a[href*="#"]', {
	topOnEmptyHash: false,
	updateURL: false,
	speed: 1000,
	speedAsDuration: true,
} );

$( function() {
	sanitizeTargetBlank();

	SameWidth.init( '.footer-navigation-container a' );

	// Add classes based on scroll position/direction
	var $html = $( 'html' );
	var lastScroll = 0;
	var newScroll = 0;

	$( window ).on( 'scroll', function( event ) {
		newScroll = $( window ).scrollTop();

		if ( newScroll > 50 ) {
			$html.removeClass( 'at-top' );

			if ( newScroll > lastScroll ) {
				$html.removeClass( 'scrolled-up' );
				$html.addClass( 'scrolled-down' );
			} else {
				$html.addClass( 'scrolled-up' );
				$html.removeClass( 'scrolled-down' );
			}

			lastScroll = newScroll;
		} else {
			$html.removeClass( 'scrolled-up' ).removeClass( 'scrolled-down' ).addClass( 'at-top' );
		}

	} );

	// Toggle
	$( '.toggle' ).on( 'click', function( clickEvent ) {
		clickEvent.preventDefault();

		var $this = $( this );
		var $target = $( $this.attr( 'data-target' ) );

		$this.toggleClass( 'active' );
		$target.toggleClass( 'active' );
		$( 'body' ).toggleClass( $this.attr( 'data-body-class' ) );
	} );

	$( '.page-toggle-nav a' ).on( 'click', function( clickEvent ) {
		clickEvent.preventDefault();

		var $this = $( this );
		var targetId = $this.attr( 'href' );

		$this.parents( '.page-toggle-nav' ).find( '.active' ).removeClass( 'active' );
		$this.addClass( 'active' );

		$( '.toggle-page' ).removeClass( 'd-lg-block' ).removeClass( 'd-flex' ).addClass( 'd-none' );
		$( targetId ).removeClass( 'd-none' ).addClass( 'd-lg-block' );
		$( targetId + '-secondary' ).removeClass( 'd-none' ).addClass( 'd-flex' );

		setTimeout( function() {
			$( window ).scrollTop( $( window ).scrollTop() + 1 ); // TODO
		}, 100 );
	} );

	$( '.fancy-select' ).on( 'change', function() {
		var $this = $( this );
		var $selected = $this.find( ':selected' );

		var targetId = $selected.attr( 'data-target' );

		$( '.toggle-page' ).removeClass( 'd-block' ).removeClass( 'd-flex' ).addClass( 'd-none' );
		$( targetId ).removeClass( 'd-none' ).addClass( 'd-block' );
		$( targetId + '-secondary' ).removeClass( 'd-none' ).addClass( 'd-flex' );

		// var offset = $( targetId ).offset();
		// var scroll = new SmoothScroll();
		// scroll.animateScroll( offset.top - 30, false, {
		// 	topOnEmptyHash: false,
		// 	updateURL: false,
		// 	speed: 1500,
		// 	speedAsDuration: true,
		// } );
	} );

	$( '.show-form' ).on( 'click', function( clickEvent ) {
		clickEvent.preventDefault();

		var $this = $( this );

		$this.hide();

		var $form = $( $this.attr( 'href' ) );

		$form.addClass( 'active' ).find( '.wpcf7-form-control:first' ).focus();
		$form.find( '.g-recaptcha' ).addClass( 'active' );
	} );

	$( '.subcounter-toggle' ).on( 'click', function() {
		$( this ).closest( '.subcounter-container' ).find( '.subcounter' ).toggle( 400 );
		$( this ).find( '.icon' ).toggleClass( 'rotate-45' );
		$( this ).find( '.open, .close' ).toggleClass( 'hidden' );

		animateInViewport();
		countUp();
	} );
} );

/**
 * Add class based on scroll direction
 */
var newScrollTop,
	currentScrollTop = 0,
	scrollTarget = $( 'body' );

$( window ).scroll( function() {
	if ( !navigator.userAgent.match( /Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile/i ) ) {
		var scrollTop = $( window ).scrollTop();

		currentScrollTop = scrollTop;

		if ( newScrollTop < currentScrollTop ) {
			scrollTarget.addClass( 'scroll-down' );
		} else if ( newScrollTop > currentScrollTop ) {
			scrollTarget.removeClass( 'scroll-down' );
		}
		newScrollTop = currentScrollTop;
	}
} );

/* 3/24/2017 Sanitize_Target_Blank.htm https://gist.github.com/JamoCA/80f65eb07f054b1326221bd4f15868d6 */
function sanitizeTargetBlank() {
	$( 'a[rel~=external]' ).prop( 'target', '_blank' );
	$( 'a[target="_blank"]' ).each( function() {
		var a = $( this );
		if ( location.hostname !== this.hostname ) {
			var originalRel = (this.rel === undefined) ? '' : this.rel.toLowerCase();
			var newRel = originalRel.split( " " );
			if ( originalRel.indexOf( 'noopener' ) === -1 ) {
				newRel.push( 'noopener' );
			}
			if ( originalRel.indexOf( 'noreferrer' ) === -1 ) {
				newRel.push( 'noreferrer' );
			}
			if ( originalRel.indexOf( 'nofollow' ) === -1 ) {
				newRel.push( 'nofollow' );
			}
			a.attr( 'rel', newRel.join( " " ).trim() );
		}
	} );
	console.log( 'External AHREF links have been sanitized.', new Date );
}

function viewRel() {
	var linkLog = [];
	console.log( 'Identifying all AHREF links with target="_blank"...' );
	$( 'a[target="_blank"]' ).each( function( i ) {
		var a = $( this );
		var r = a.attr( 'rel' );
		if ( r !== undefined ) {
			r = r.split( " " );
		}
		var entry = {
			'index': i,
			'linkText': a.text(),
			'href': a.attr( 'href' ),
			'target': a.attr( 'target' ),
			'rel': r,
		};
		linkLog.push( entry );
	} );
	console.table( linkLog );
}
